<template>
  <div>
    <div class="row">
      <div v-if="uploaderProfile.artwork" class="col-4">
        <strong><u>{{ getItemLabel(true) }} Artwork</u></strong><br>
        <img :src="uploaderProfile.artwork.thumbnail_path" width="100%">
      </div>
      <div class="col-8">
        <strong><u>{{ getItemLabel(true) }} Information</u></strong><br>
        <span v-if="uploaderProfile.artwork">&nbsp;<br></span>
        <strong>File name will become : </strong><i>{{ fileName }}</i><br>
        <strong>{{ getItemLabel(true) }} name will become : </strong>{{ previewTextField(uploaderProfile.settings.item_name_structure) }}<br>
        <strong>{{ getItemLabel(true) }} description will become : </strong>{{ previewTextField(uploaderProfile.settings.item_description_structure) }}<br>
        <span v-if="tags"><strong>The {{ getItemLabel(true) }} will have tags : </strong>{{ tags }}<br></span>
        <strong>Publish Information : </strong>{{ published_text }}
      </div>
    </div>
  </div>
</template>

<script>
import UploaderProfilesMixin from "VueMixins/UploaderProfilesMixin";

export default {
  mixins: [UploaderProfilesMixin],
  props: {
    uploaderProfile: {
      type: Object,
      required: true,
    },
    fileName: {
      type: String,
      required: false,
      default: "john_doe_breakfast_show_01-01-2019.mp3",
    },
  },
  data() {
    return {};
  },
  computed: {
    tags() {
      if (!this.uploaderProfile.settings.tags) {
        return null;
      }
      return this.uploaderProfile.settings.tags.join(", ");
    },
    published_text() {
      let text = '';

      const settings = this.uploaderProfile.settings;
      const approval_required = this.uploaderProfile.approval_required;

      const should_publish_immediately = settings.published ||
        (!settings.publish_delay.days && !settings.publish_delay.hours && !settings.publish_delay.minutes);

      if (should_publish_immediately) {
        if (approval_required) {
          text += `The ${this.getItemLabel(true)} will be published as soon as it's approved`;
        } else {
          text += `The ${this.getItemLabel(true)} will be published immediately`;
        }
      } else {
        const publish_parts = [
` The ${this.getItemLabel(true)} will be published`,
        ];
        if (settings.publish_delay.days) {
          publish_parts.push(`${settings.publish_delay.days} day(s)`);
        }
        if (settings.publish_delay.hours) {
          publish_parts.push(`${settings.publish_delay.hours} hours(s)`);
        }
        if (settings.publish_delay.minutes) {
          publish_parts.push(`${settings.publish_delay.minutes} minutes(s)`);
        }

        publish_parts.push(`after the file is ${approval_required ? 'approved' : 'uploaded'}`);

        text += publish_parts.join(" ");
      }

      if (!settings.publish_duration.days && !settings.publish_duration.hours && !settings.publish_duration.minutes) {
        text += ` and the ${this.getItemLabel(true)} will remain published until manually unpublished.`;
      } else {
        const unpublish_parts = [
          ` and the ${this.getItemLabel(true)} will be unpublished`,
        ];
        if (settings.publish_duration.days) {
          unpublish_parts.push(`${settings.publish_duration.days} day(s)`);
        }
        if (settings.publish_duration.hours) {
          unpublish_parts.push(`${settings.publish_duration.hours} hours(s)`);
        }
        if (settings.publish_duration.minutes) {
          unpublish_parts.push(`${settings.publish_duration.minutes} minutes(s)`);
        }
        unpublish_parts.push(`after the file is published.`);
        text += unpublish_parts.join(" ");
      }

      return text;
    },
  },
  mounted() {
    if (this.fileName) {
      this.example_file_name = this.fileName;
    }
    // Is this a saved uploader profile ? If it is we need to convert certain settings for display.
    if (this.uploaderProfile.uuid) {
      // Saved profiles have publish duration as seconds. Convert this to days, hours & minutes object
      if (this.uploaderProfile.settings?.publish_duration) {
        this.publish_duration = this.convertSecondsToDaysHoursMinutes(this.uploaderProfile.settings.publish_duration);
      }
      // Saved profiles have publish duration as seconds. Convert this to days, hours & minutes object
      if (this.uploaderProfile.settings?.publish_delay) {
        this.publish_delay = this.convertSecondsToDaysHoursMinutes(this.uploaderProfile.settings.publish_delay);
      }
    }
  },
  methods: {
    previewTextField(field) {
      if (!field) {
        const last_file_name_part = this.fileName.split('.').pop();
        // Remove the file extension from the file name
        return this.fileName.replace(`.${last_file_name_part}`, '');
      }

      let preview_item_name = field.replace("[sanitised_file_name]", this.sanitised_file_name);

      const todays_date = window.moment().format('DD/MM/YYYY');
      const todays_datetime = window.moment().format('DD/MM/YYYY HH:mm:ss');

      preview_item_name = preview_item_name.replace("[date]", todays_date);
      preview_item_name = preview_item_name.replace("[datetime]", todays_datetime);
      preview_item_name = preview_item_name.replace("[customer]", window.user.customer.name);

      return preview_item_name;
    },
  },
};
</script>
